import React, { useState } from 'react';
import { ArrowLeftIcon, PenIcon, ChevronRightIcon, UserIcon } from 'lucide-react';
export function ProfileEditScreen({
  onBack,
  userProfile = {},
  onChangePassword
}) {
  const defaultProfile = {
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@gmail.com',
    phone: '',
    ...userProfile
  };
  const [profile, setProfile] = useState(defaultProfile);
  const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setProfile({
      ...profile,
      [name]: value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real app, this would save the profile to the server
    console.log('Profile saved:', profile);
    onBack();
  };
  return <div className="space-y-6" data-id="element-390">
      <div className="flex items-center" data-id="element-391">
        <button onClick={onBack} className="p-1 rounded-full hover:bg-gray-100" aria-label="Back" data-id="element-392">
          <ArrowLeftIcon className="w-6 h-6 text-gray-500" data-id="element-393" />
        </button>
        <h2 className="ml-4 text-xl font-semibold" data-id="element-394">Edit Profile</h2>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-395">
        {/* Profile Picture */}
        <div className="flex flex-col items-center justify-center py-6 bg-white rounded-lg shadow" data-id="element-396">
          <div className="bg-black text-white rounded-full w-24 h-24 flex items-center justify-center text-3xl font-bold" data-id="element-397">
            {profile.firstName && profile.lastName ? `${profile.firstName.charAt(0)}${profile.lastName.charAt(0)}` : <UserIcon className="w-12 h-12" data-id="element-398" />}
          </div>
        </div>
        {/* Form Fields */}
        <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-399">
          <div className="divide-y divide-gray-200" data-id="element-400">
            {/* First Name */}
            <div className="p-4" data-id="element-401">
              <label htmlFor="firstName" className="block text-sm text-gray-500 mb-1" data-id="element-402">
                First name
              </label>
              <input type="text" id="firstName" name="firstName" value={profile.firstName} onChange={handleChange} className="w-full p-2 border-0 focus:ring-0 text-lg" placeholder="Enter your first name" data-id="element-403" />
            </div>
            {/* Last Name */}
            <div className="p-4" data-id="element-404">
              <label htmlFor="lastName" className="block text-sm text-gray-500 mb-1" data-id="element-405">
                Last name
              </label>
              <input type="text" id="lastName" name="lastName" value={profile.lastName} onChange={handleChange} className="w-full p-2 border-0 focus:ring-0 text-lg" placeholder="Enter your last name" data-id="element-406" />
            </div>
            {/* Email */}
            <div className="p-4" data-id="element-407">
              <label htmlFor="email" className="block text-sm text-gray-500 mb-1" data-id="element-408">
                Email
              </label>
              <input type="email" id="email" name="email" value={profile.email} onChange={handleChange} className="w-full p-2 border-0 focus:ring-0 text-lg" placeholder="Enter your email" data-id="element-409" />
            </div>
            {/* Phone */}
            <div className="p-4" data-id="element-410">
              <label htmlFor="phone" className="block text-sm text-gray-500 mb-1" data-id="element-411">
                Phone number
              </label>
              <input type="tel" id="phone" name="phone" value={profile.phone} onChange={handleChange} className="w-full p-2 border-0 focus:ring-0 text-lg" placeholder="Add your phone number" data-id="element-412" />
            </div>
          </div>
        </div>
        {/* Change Password */}
        <div className="bg-white rounded-lg shadow" data-id="element-413">
          <button type="button" onClick={onChangePassword} className="w-full flex items-center justify-between p-4 text-left" data-id="element-414">
            <div className="flex items-center" data-id="element-415">
              <PenIcon className="w-5 h-5 text-gray-500 mr-3" data-id="element-416" />
              <span className="text-lg" data-id="element-417">Change password</span>
            </div>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-418" />
          </button>
        </div>
        {/* Deactivate Account */}
        <button type="button" onClick={() => setShowDeactivateConfirm(true)} className="w-full text-left text-red-600 font-medium py-4" data-id="element-419">
          Close account
        </button>
        {/* Save Button */}
        <div className="pt-4" data-id="element-420">
          <button type="submit" className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-421">
            Save Changes
          </button>
        </div>
      </form>
      {/* Deactivate Confirmation Modal */}
      {showDeactivateConfirm && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-422">
          <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl" data-id="element-423">
            <h3 className="text-xl font-semibold mb-4" data-id="element-424">Close Your Account?</h3>
            <p className="text-gray-600 mb-6" data-id="element-425">
              Are you sure you want to close your account? This action cannot be
              undone and all your data will be permanently deleted.
            </p>
            <div className="flex justify-end space-x-3" data-id="element-426">
              <button onClick={() => setShowDeactivateConfirm(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-427">
                Cancel
              </button>
              <button onClick={() => {
            console.log('Account deactivation requested');
            setShowDeactivateConfirm(false);
          }} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-428">
                Close Account
              </button>
            </div>
          </div>
        </div>}
    </div>;
}